
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { addItem, removeItem } from '@/utils/arrays'
import { strToDateArray, timeJoin } from '@/utils/dateTime'

@Component({
  name: 'indExtra',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any
  private extraParam: any = {
    open_time: [],
    jump_checkout_counter_mode: '',
  }

  private mcList: any = []

  private accountType: any = []
  private openTimes: any[] = [
    [new Date('2021/01/01 00:00'), new Date('2021/01/01 23:59')],
  ]

  // 收银台比率数据展示
  private serverModeList: any = []
  private onData() {
    if (
      !this.product.checkout_counter_rate.server &&
      !this.product.checkout_counter_rate.oss
    ) {
      this.serverModeList = [
        {
          name: 'server',
          rate: '',
          success_volume: '',
          time: '',
          volume: '',
        },
        {
          name: 'oss',
          rate: '',
          success_volume: '',
          time: '',
          volume: '',
        },
      ]
    } else {
      this.serverModeList = [
        {
          name: 'server',
          rate: this.product.checkout_counter_rate.server.rate,
          success_volume:
            this.product.checkout_counter_rate.server.success_volume,
          time: this.product.checkout_counter_rate.server.time,
          volume: this.product.checkout_counter_rate.server.volume,
        },
        {
          name: 'oss',
          rate: this.product.checkout_counter_rate.oss.rate,
          success_volume: this.product.checkout_counter_rate.oss.success_volume,
          time: this.product.checkout_counter_rate.oss.time,
          volume: this.product.checkout_counter_rate.oss.volume,
        },
      ]
    }
  }

  private addItem = addItem
  private removeItem = removeItem

  private addMc() {
    this.product.extra_param.mc_list.push('')
  }
  private removeMc(index: number) {
    this.product.extra_param.mc_list.splice(index, 1)
  }

  private addCm() {
    this.mcList.push('')
  }
  private removeCm(index: number) {
    this.mcList.splice(index, 1)
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  @Watch('product')
  private onProductChange() {
    const times: any[] = this.product.extra_param.open_time
    if (times.length > 0) {
      this.openTimes = []
      times.forEach((time: any) => {
        this.openTimes.push(strToDateArray(time))
      })
      this.extraParam.open_time = this.product.extra_param.open_time
    }
  }

  private async extraUpdate() {
    this.extraParam.open_time = []
    this.openTimes.forEach((time: any) => {
      if (time[0]) {
        const str = timeJoin(time[0], time[1])
        this.extraParam.open_time.push(str)
      }
    })
    // 清空未输入
    this.product.extra_param.mc_list = this.product.extra_param.mc_list.filter(
      (item) => item !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        open_time: this.extraParam.open_time,
        mc_list: this.product.extra_param.mc_list,
      },
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success',
      })
      this.flagStr()
      this.back()
    })
  }

  private async noExtraUpdate() {
    this.extraParam.open_time = []
    this.openTimes.forEach((time: any) => {
      if (time[0]) {
        const str = timeJoin(time[0], time[1])
        this.extraParam.open_time.push(str)
      }
    })
    // 清空未输入
    this.mcList = this.mcList.filter((item) => item !== '')
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        open_time: this.extraParam.open_time,
        mc_list: this.mcList,
      },
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success',
      })
      this.flagStr()
      this.back()
    })
  }

  // 跳转收银台模式
  private exists: any = ''
  private async checkoutCounterMode() {
    if (this.product.extra_param.jump_checkout_counter_mode) {
      this.exists = this.product.extra_param.jump_checkout_counter_mode
    } else {
      this.exists = this.extraParam.jump_checkout_counter_mode
    }
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        jump_checkout_counter_mode: this.exists,
      },
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success',
      })
      this.flagStr()
      this.back()
    })
  }

  mounted() {
    if (this.product.extra_param.open_time) {
      this.openTimes = []
      let times: any[] = this.product.extra_param.open_time
      if (times.length > 0) {
        times.forEach((time: any) => {
          this.openTimes.push(strToDateArray(time))
        })
        this.extraParam = {
          open_time: this.product.extra_param.open_time,
        }
      }
      let mc_list: string[] = this.product.extra_param.mc_list
      if (mc_list.length > 0) {
      }
    }
    this.onData()
  }
}
